export type TriagePromptFilters = {
  statuses: readonly string[];
  severity: string;
  tagNames: readonly string[];
  applicationId: string;
  search?: string;
};

function quoteIfNeeded(value: string): string {
  return /\s/.test(value) ? `"${value.replace(/"/g, '\\"')}"` : value;
}

export function buildTriagePrompt(filters: TriagePromptFilters): string {
  const onlyOpen = filters.statuses.length === 1 && filters.statuses[0] === 'open';
  const listParts = ['cofactor issues list'];
  if (filters.statuses.length > 0) listParts.push(`--status ${filters.statuses.join(',')}`);
  if (filters.severity !== 'all') listParts.push(`--severity ${filters.severity}`);
  if (filters.tagNames.length > 0) {
    listParts.push(`--tag ${filters.tagNames.map(quoteIfNeeded).join(',')}`);
  }
  if (filters.applicationId !== 'all') listParts.push(`--application-id ${filters.applicationId}`);
  const search = filters.search?.trim();
  if (search) listParts.push(`--search "${search.replace(/"/g, '\\"')}"`);
  listParts.push('--json');

  return [
    onlyOpen ? 'Triage the open Cofactor issues.' : 'Triage the Cofactor issues.',
    '',
    'Use the Cofactor MCP server (cofactor_issues_list / cofactor_issues_get) or the Cofactor CLI:',
    `  ${listParts.join(' ')}`,
    'No CLI? npm install -g @runcofactor/cli && cofactor login',
    '',
    'For each issue, read it (`cofactor issues get <id>`), then:',
    '- merge duplicates:',
    '  cofactor issues merge <dupId> --into <canonicalId>',
    "- close what isn't a bug:",
    '  cofactor issues close <id> --not-a-bug --reason "<why>"',
    '- rank the rest by severity and user impact.',
    '',
    "Report a table (issue, verdict, why, next step). Don't change code yet.",
  ].join('\n');
}
